import { Button, Modal, Tooltip } from 'antd';
import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { declOfNum } from '../../../../../../helpers/dspx-utils';
import deleteFile from '../../../../store/thunks/deleteFile';
import { useHistory, useLocation } from 'react-router';
import useFilesQuery from '../../../../hooks/useFilesQuery';

const { confirm } = Modal;

const DeleteFile = ({ fileId }) => {
  const history = useHistory();
  const location = useLocation();

  const { openedFile, listLoading } = useSelector((store) => store.debtsStore);
  const { refetch } = useFilesQuery();

  const params = new URLSearchParams(location.search);
  const companyIdFromUrl = params.get('companyId');

  const noticesAmount = openedFile?.notices?.length;
  const noticesWillBeDeletedText = noticesAmount
    ? `${noticesAmount} ${declOfNum(noticesAmount, [
        'оповещение',
        'оповещения',
        'оповещений',
      ])} по файлу тоже ${noticesAmount > 1 ? 'будут' : 'будет'} ${
        noticesAmount > 1 ? 'удалены' : 'удалено'
      }.`
    : '';
  const handleDeleteClick = useCallback(
    (e) => {
      e.stopPropagation();
      confirm({
        title: 'Вы уверены, что хотите удалить файл?',
        content: (
          <>
            <span>Удалить файл можно в течение суток после загрузки.</span>
            <br />
            <strong>{noticesWillBeDeletedText}</strong>
          </>
        ),
        okText: 'Ок',
        okType: 'danger',
        cancelText: 'Отмена',
        onOk() {
          deleteFile(fileId).finally(() => {
            history.push({
              pathname: '/Debts',
              search: `?companyId=${companyIdFromUrl}`,
            });
            refetch();
          });
        },
      });
    },
    [fileId, noticesWillBeDeletedText, companyIdFromUrl]
  );

  return (
    <Tooltip
      title={
        !!noticesAmount || listLoading
          ? '"Загрузка не может быть удалена, т.к. было запущено оповещение о задолженности'
          : ''
      }
    >
      <Button
        type="primary"
        className="button"
        onClick={handleDeleteClick}
        disabled={!!noticesAmount || listLoading}
      >
        Удалить
      </Button>
    </Tooltip>
  );
};

export default memo(DeleteFile);
